"use client";

import React, { FC, PropsWithChildren } from "react";
import { Box, Stack, Flex, AbsoluteCenter } from "@chakra-ui/react";
import NextLink from "next/link";
import { Global, css } from "@emotion/react";
import Button from "../Button";
import BasicPageLayout from "./BasicPageLayout";

type Props = {
  title: string;
  links?: { label: string; url: string }[];
  direction?: "row" | "column";
  showBackLink?: boolean;
};

const TwoColumnCenteredPageLayout: FC<PropsWithChildren<Props>> = ({
  title,
  links = [],
  direction = "row",
  showBackLink,
  children,
}) => (
  <>
    <Global
      styles={css`
        @media screen and (min-width: 64rem) {
          body {
            background-color: #f7fafc;
          }
        }
      `}
    />

    <BasicPageLayout title={title} showBackLink={showBackLink}>
      <AbsoluteCenter
        position={{ md: "absolute" }}
        translate={{ md: "-50% -50%" }}
        top={{ md: "50%" }}
        left={{ md: "50%" }}
        px={5}
      >
        <Box m="auto" px={5}>
          <Stack gap={6}>
            <Flex
              gap={3}
              flexDirection={direction}
              flexWrap="wrap"
              justifyContent="center"
            >
              {React.Children.toArray(children)
                .filter(Boolean)
                .map((child, index) => (
                  <Stack
                    key={index}
                    alignSelf="flex-start"
                    w="100vw"
                    maxWidth={400}
                    bg="#fff"
                    borderRadius={20}
                    p={5}
                    boxShadow={{
                      md: "-4px 20px 45px -35px rgba(0, 0, 0, 0.2)",
                    }}
                  >
                    {child}
                  </Stack>
                ))}
            </Flex>

            {Boolean(links.length) && (
              <Flex
                gapX={{ base: 3, md: 5 }}
                gapY={1}
                alignItems={{ base: "flex-start", md: "flex-end" }}
                justifyContent="center"
                flexWrap="wrap"
                pb={3}
                px={5}
              >
                {links.map(({ label, url }) => (
                  <Button
                    key={label}
                    asChild
                    visual="link"
                    justifySelf="center"
                  >
                    <NextLink href={url}>{label}</NextLink>
                  </Button>
                ))}
              </Flex>
            )}
          </Stack>
        </Box>
      </AbsoluteCenter>
    </BasicPageLayout>
  </>
);

export default TwoColumnCenteredPageLayout;
